let recSlider = document.querySelector('.rec-slider')

if(recSlider) {
    new Swiper(recSlider, {
		slideClass: 'product',
		loop: false,
		speed: 600,
		slidesPerView: 1,
		spaceBetween: 50,
		breakpoints: {
            768: {
                slidesPerView: 2
            },
            1025: {
                slidesPerView: 4
            }
        },
        pagination: {
            el: '.recPagination'
        }
	})
}

/////

let singleSlider = document.querySelector('.single-slider')
let singleSliderNav = document.querySelector('.single-slider-nav')

if(singleSlider && singleSliderNav) {
    function updateNav() {
        let index = slider.activeIndex || 0
        let tabs = singleSliderNav.children

        for(let tab of tabs) {
            let tabIndex = tab.index()

            if(tabIndex == index) {
                tab.classList.add('active')
            } else {
                tab.classList.remove('active')
            }
        }
    }

    let slider = {}
    
    slider = new Swiper(singleSlider, {
        slideClass: 'image',
		loop: false,
		speed: 600,
        slidesPerView: 1,
        on: {
            slideChange: updateNav
        }
    })

    for(let tab of singleSliderNav.children) {
        tab.addEventListener('click', () => {
            let index = tab.index()
            slider.slideTo(index)
        })
    }

    let images = singleSlider.querySelectorAll('.image')

    if(images.length) {
        let options = []
    
        for(let image of images) {
            let img = image.querySelector('img')
            let src = img.getAttribute('src')
            
            options.push({
                src: src,
                type: 'image'
            })
    
            image.addEventListener('click', () => {
                let other = Array.prototype.slice.call( images )
                let index = other.indexOf(image)
            
                Fancybox.show(
                    options,
                    {
                        startIndex: index,
                        infinite: false,
                    }
                )
            })
        }
    }
}

/////

let showAllOptions = document.querySelector('.show-all-options')

if(showAllOptions) {
    showAllOptions.addEventListener('click', () => {
        let optionsTab = document.querySelector('.options-tab')

        if(optionsTab) {
            optionsTab.open()
            optionsTab.scrollIntoView({
                behavior: 'smooth'
            })
        }
    })
}

/////